import { render, staticRenderFns } from "./Chargeback.vue?vue&type=template&id=788c7cbc&scoped=true&"
import script from "./Chargeback.vue?vue&type=script&lang=js&"
export * from "./Chargeback.vue?vue&type=script&lang=js&"
import style0 from "./Chargeback.vue?vue&type=style&index=0&id=788c7cbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788c7cbc",
  null
  
)

export default component.exports